(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sl-brand-support"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sl-brand-support')){
  customElements.define('sl-brand-support',class extends HTMLElement{
    connectedCallback(){
      this.openPolicy=()=>{
        const id=window.location.hash.slice(1);
        if(!id.startsWith('sl-policy-'))return;
        const target=document.getElementById(id);
        if(target&&this.contains(target)&&target.matches('details[data-sl-policy]'))target.open=true;
      };
      this.handleLink=(event)=>{
        const link=event.target.closest('a[data-sl-policy-link]');
        if(!link)return;
        const target=document.getElementById(link.getAttribute('href').slice(1));
        if(target&&this.contains(target)&&target.matches('details[data-sl-policy]'))target.open=true;
      };
      document.addEventListener('click',this.handleLink);
      window.addEventListener('hashchange',this.openPolicy);
      this.openPolicy();
    }
    disconnectedCallback(){document.removeEventListener('click',this.handleLink);window.removeEventListener('hashchange',this.openPolicy);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sl-outfit-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sl-outfit-form')) {
  customElements.define('sl-outfit-form', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.pieces = [...this.querySelectorAll('[data-piece]')];
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => this.submit(event));
      this.update();
    }
    selected() { return this.pieces.filter(piece => piece.querySelector('[data-include]').checked); }
    update() {
      if (this.busy) return;
      this.pieces.forEach(piece => {
        const included = piece.querySelector('[data-include]').checked;
        piece.querySelector('[data-size]').disabled = !included;
        piece.querySelector('[data-size]').required = included;
        piece.querySelector('[data-quantity]').disabled = !included;
      });
      const selected = this.selected();
      const ready = selected.length > 0 && selected.every(piece => piece.querySelector('[data-size]').value);
      const total = selected.reduce((sum, piece) => sum + Number(piece.querySelector('[data-size]').selectedOptions[0]?.dataset.price || 0), 0);
      this.querySelector('[data-total]').textContent = ready ? new Intl.NumberFormat(this.dataset.locale || 'en-GB', { style: 'currency', currency: this.dataset.currency || 'GBP' }).format(total / 100) : '—';
      this.button.disabled = !ready;
      const anyAvailable = this.pieces.some(piece => !piece.querySelector('[data-include]').disabled);
      this.button.textContent = !anyAvailable ? this.dataset.unavailable : !selected.length ? this.dataset.empty : ready ? (selected.length === 2 ? this.dataset.set : this.dataset.single) + ' — ' + this.querySelector('[data-total]').textContent : this.dataset.choose;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      const items = this.selected().map(piece => ({ id: Number(piece.querySelector('[data-size]').value), quantity: 1 }));
      if (!items.length || items.some(item => !Number.isSafeInteger(item.id) || item.id <= 0)) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.dataset.busy;
      this.status.textContent = '';
      this.querySelector('[data-cart-link]').hidden = true;
      try {
        const response = await fetch(this.dataset.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: ['cart-icon-bubble'] }), credentials: 'same-origin' });
        const result = await response.json().catch(() => null);
        if (!response.ok || !Array.isArray(result?.items)) {
          const failure = new Error(this.dataset.error);
          failure.customerMessage = typeof result?.description === 'string' ? result.description : this.dataset.error;
          throw failure;
        }
        this.status.textContent = this.dataset.success;
        this.querySelector('[data-cart-link]').hidden = false;
        const cartIcon = document.getElementById('cart-icon-bubble');
        const iconHtml = result.sections?.['cart-icon-bubble'];
        if (cartIcon && iconHtml) {
          const parsed = new DOMParser().parseFromString(iconHtml, 'text/html');
          cartIcon.innerHTML = (parsed.querySelector('.shopify-section') || parsed.body).innerHTML;
        }
        document.dispatchEvent(new CustomEvent('screwloose:cart-updated'));
      } catch (error) {
        this.status.textContent = error.customerMessage || this.dataset.error;
        this.querySelector('[data-cart-link]').hidden = false;
      } finally {
        this.busy = false;
        this.update();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
